/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 25.04.2016.
 */

import React, {Component, PropTypes} from 'react';

/**
 * @class DivLoader
 * @extends React.Component
 */
class DivLoader extends Component {

  constructor(props) {
    super(props);

    this.state = {
      visible: true
    };
  }
  
  render() {

    let styleCSS = {
      display: this.props.loading ? 'block' : 'none',
      opacity: this.props.loading ? 1 : 0
    };

    return <div className="ui active dimmer radius" style={styleCSS}>
      <div className="ui indeterminate loader"></div>
    </div>;
  }
}

DivLoader.propTypes = {
  loading: PropTypes.bool
};

DivLoader.defaultProps = {
  loading: false
};

export default DivLoader;



// WEBPACK FOOTER //
// ./src/components/DivLoader/div-loader.js